<template>
  <header v-if="content" class="bg-grey text-center px-5 py-10 md:py-13 transition-[padding]">
    <div class="max-w-212.5 mx-auto">
      <h1 class="font-semibold text-4xl md:text-6xl">{{ content.title }}</h1>
      <p v-if="content.description" class="text-grey-dark mt-2.5 md:mt-4">{{ content.description }}</p>
      <slot/>
    </div>
  </header>
</template>

<script lang="ts">
import type {PropType} from "vue";

export default {
  name: 'PageHeader',
  props: {
    content: {
      type: Object as PropType<PageHeader | null>,
      required: true
    }
  }
}
</script>
